module.exports = __webpack_public_path__ + "static/history-stage-jul-2023-dd8f660d3ab2278a9a47c8bcb4a67fbb.jpg";